import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "AvMed Marketplace",
  shortName: "AvMed Marketplace",
  slug: "avmed-marketplace-insurance",
  seoTitle: "AvMed Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have an AvMed Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "AvMed Marketplace TMS coverage, AvMed TMS therapy, AvMed ACA depression treatment Florida, AvMed Marketplace mental health benefits, AvMed SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "AvMed offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov) for Florida residents. These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because AvMed Marketplace plans come in different metal tiers, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.avmed.org/",
  officialResourceLabel: "AvMed Marketplace plans",
};

export const AvMedMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AvMedMarketplaceInsurance;
